export default __webpack_public_path__ + "static/manufacturing2-08cdff5c25ee6c9d6c28f1f33ac8f092.png";